import { useAppContext } from '@contexts/app/hooks/useAppContext';
import { WhitelabelId } from '@whitelabel/WhitelabelId';

export const useIsAgoda = () => {
    const { whitelabelId } = useAppContext();
    return whitelabelId === WhitelabelId.AGODA || whitelabelId === WhitelabelId.AGODAUAT;
};
